import React from "react";
import styled from "styled-components";

export default function ProductBox({ img, title, text, href, target, alt}) {
  return (
    <Wrapper>
      <Anchor className="animate pointer" href={href} target={target}>
        <img className="radius8" src={img} alt={alt}></img>
      </Anchor>
      <h3 className="font20 extraBold">{title}</h3>
      <p className="font13">{text}</p>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  width: 100%;
  margin-top: 30px;
  img {
    width: 100%;
    height: auto;
    margin: 20px 0;
    max-width: 395px;
    max-height: 418px;
    transition: .5s;
    @media (max-width: 859px) {
      margin: 15px 0 10px;
    }
    :hover {
      transition: .5s;
      transform: scale(1.03);
    }
  }
  h3 {
    padding-bottom: 10px;
  }
`;
const Anchor = styled.a`
  background-color: transparent;
  border: 0px;
  outline: none;
  padding: 0px;
  margin: 0px;
`;